import { useDispatch } from "react-redux";
import { useCallback } from "react";
// import { validateToken, logoutUser } from "../redux/actions"; // adjust paths
import { validateToken, logoutUser } from "../features/cred/credSlice";
import { toast } from "react-toastify";

const useTokenValidation = () => {
  const dispatch = useDispatch();

  const validateAndHandleToken = useCallback(async (token) => {
    const fetchedToken = token || localStorage.getItem('token');
    console.log('...fetchedToken...', fetchedToken);
    const response = await dispatch(validateToken(fetchedToken));
    if (!response?.payload?.valid || localStorage.getItem('token') === null) {
      console.error("Token invalid or expired");
      dispatch(logoutUser());
      toast.error("Invalid Token! Logging out...");
      return false;
    } else {
        return response?.payload?.user;
    }
    // return true;
  }, [dispatch]);

  return { validateAndHandleToken };
};

export default useTokenValidation;